// tool-shell.jsx: shell voor de losse tools (eigen slug per tool, zie main.jsx)
// Toont dezelfde TopBar als de volledige calculator en een eigen progress-bar.
// Het algemene tools-overzicht leeft op een aparte omgeving; vandaar geen
// "Alle tools"-link hier (zet 'm terug zodra de externe hub-URL bekend is).
import React from "react";
import { StepProgress } from "../ui/primitives";
import { TopBar } from "../App";

export const ToolShell = ({
  steps,
  currentStep,
  onJumpTo,
  children,
}) => (
  <div>
    <TopBar />
    {currentStep > 0 && (
      <div className="progress-bar">
        <div className="progress-bar-inner" style={{ display: "flex", justifyContent: "center" }}>
          <StepProgress steps={steps} current={currentStep} onJumpTo={onJumpTo} />
        </div>
      </div>
    )}
    <div className="app-shell">
      {children}
    </div>
  </div>
);
